import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Haunzhe"
});
const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.4108 11.8658C11.9807 11.7099 11.5476 11.5929 11.1253 11.5063C11.7814 11.0906 12.364 10.5379 12.7312 9.70647C13.8254 7.6999 13.0225 5.14061 11.0543 4.03282C9.08618 2.92503 6.53298 3.68678 5.51218 5.76301C4.49139 7.83925 5.22088 10.3985 7.3359 11.5063C4.63582 12.0614 1.5 13.9286 1.5 19.0495C1.5 20.4337 3.25028 20.4337 9.23059 20.4337H9.23061H9.23064C10.9152 20.4337 12.2677 20.4337 13.3405 20.4016C12.0067 19.2446 11.1633 17.5374 11.1633 15.6331C11.1633 14.221 11.6271 12.9172 12.4108 11.8658Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.6",
  d: "M22.0797 11.9359C21.8627 11.267 21.1924 10.7518 20.6882 10.4457C20.3438 10.2374 19.9046 10.2325 19.5552 10.4332L18.6551 10.9507C18.248 11.1847 17.7375 11.1847 17.3304 10.9507L16.4307 10.4332C16.0813 10.2325 15.6421 10.2374 15.2977 10.4457C14.7928 10.7518 14.1225 11.267 13.9055 11.9359C13.5424 13.0546 12.9983 14.4314 14.3588 15.9805C14.3588 15.9805 13.6335 18.9067 15.3564 20.2835C15.3564 20.2835 16.6153 20.8211 16.4452 19.7671C16.3348 19.0825 16.3429 16.5466 17.9926 16.4227C19.6426 16.5466 19.6507 19.0828 19.54 19.7671C19.3703 20.8211 20.6285 20.2835 20.6285 20.2835C22.3521 18.9067 21.6264 15.9805 21.6264 15.9805C22.9872 14.4318 22.4428 13.0546 22.0797 11.9359Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var haunzhe = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { haunzhe as default };
